import React from 'react';
const initialTimeStarted = -1;
const initialTimePlayed = 0;
const initialDuration = 0;
const initialViewed = false;

// TODO should have in count the reproduction velocity (example X2) if it is allowed (in X2 time must be half duration etc)

export const useArchiveMediaViewed = onViewed => {
  const timeStarted = React.useRef(initialTimeStarted);
  const timePlayed = React.useRef(initialTimePlayed);
  const duration = React.useRef(initialDuration);
  const viewed = React.useRef(initialViewed);
  const onLoadedMetadata = React.useCallback(e => {
    duration.current = e.currentTarget.duration;
    timeStarted.current = initialTimeStarted;
    timePlayed.current = initialTimePlayed;
    viewed.current = initialViewed;
  }, []);
  const onStartedPlaying = React.useCallback(() => {
    timeStarted.current = new Date().getTime() / 1000;
  }, []);
  const onStoppedPlaying = React.useCallback(e => {
    if (timeStarted.current > 0) {
      const playedFor = new Date().getTime() / 1000 - timeStarted.current;
      timeStarted.current = -1;
      timePlayed.current += playedFor;
    }
    if (timePlayed.current >= duration.current && e.type === 'ended' && !viewed.current) {
      viewed.current = true;
      onViewed && onViewed();
    }
  }, []);
  return {
    onLoadedMetadata,
    onStartedPlaying,
    onStoppedPlaying
  };
};